module.exports = __webpack_public_path__ + "static/LipTrioRose-3eceebefd597634f7cc4f1831db0746d.jpg";